import { createRouter, createWebHistory } from "vue-router";

const pcRoutes = [
    {
        path: "/",
        name: "pc-layout",
        component: () => import("@/layouts/PCLayout.vue"),
        meta: {
            title: '首页',
            description: '图公主（Lenmory）是一款智能相机应用，支持重复擦写、AI识别等功能。',
            keywords: '图公主,Lenmory,智能相机'
        },
        children: [
            {
                path: '',
                name: 'pc-home',
                component: () => import("@/views/pc/HomePage.vue"),
            },
            {
                path: "/login",
                name: "login",
                component: () => import("@/views/pc/LoginPage.vue"),
                meta: {
                    title: '登录',
                    description: '登录图公主账号，同步您的数据和设置。',
                    keywords: '图公主登录,Lenmory登录'
                },
            },
            {
                path: "/qa",
                component: () => import("@/views/pc/QAPage.vue"),
                meta: {
                    title: '使用答疑',
                    description: '图公主使用答疑，解答您在使用过程中遇到的常见问题。',
                    keywords: '图公主答疑,使用帮助,常见问题'
                },
                children: [
                    {
                        path: "/tutorial",
                        name: "tutorial",
                        component: () => import("@/views/pc/TutorialPage.vue"),
                        meta: {
                            title: '七步教程',
                            description: '图公主七步教程，快速掌握智能相机的核心功能。',
                            keywords: '图公主教程,使用教程,快速上手'
                        },
                    },
                ]
            },
        ]
    },
];

const mobileRoutes = [
    {
        path: "/m/",
        name: "mobile-layout",
        component: () => import("@/layouts/MobileLayout.vue"),
        meta: {
            title: '首页',
            description: '图公主（Lenmory）是一款智能相机应用，支持重复擦写、AI识别等功能。',
            keywords: '图公主,Lenmory,智能相机'
        },
        children: [
            {
                path: '',
                name: 'mobile-home',
                component: () => import("@/views/mobile/HomePage.vue"),
            },
            {
                path: 'start',
                name: 'mobile-tutorial',
                component: () => import("@/views/mobile/TutorialPage.vue"),
                meta: {
                    title: '七步教程',
                    description: '图公主七步教程，快速掌握智能相机的核心功能。',
                    keywords: '图公主教程,使用教程,快速上手'
                },
            },
            {
                path: 'mobile-more',
                name: 'mobile-more',
                component: () => import("@/views/mobile/DetailPage.vue"),
                meta: {
                    title: '详细',
                    description: '图公主详细介绍，了解智能相机的全部功能。',
                    keywords: '图公主功能,产品介绍'
                },
            },
        ]
    },
];

const pdfRoutes = [
    {
        path: "/pdf/:name",
        name: "pc-pdf",
        component: () => import("@/views/pc/PdfViewer.vue"),
        meta: {
            title: '产品说明',
            description: '图公主产品说明书。',
            keywords: '图公主,产品说明'
        },
    },
    {
        path: "/m/pdf/:name",
        name: "mobile-pdf",
        component: () => import("@/views/mobile/PdfViewer.vue"),
        meta: {
            title: '产品说明',
            description: '图公主产品说明书。',
            keywords: '图公主,产品说明'
        },
    },
];

const redirectRoutes = [
    {
        path: "/m/download/app/memobus/:pathMatch(.*)*",
        redirect: "/"
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes: [...pcRoutes, ...mobileRoutes, ...pdfRoutes, ...redirectRoutes],
    // 添加滚动行为配置
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    }
});

router.beforeEach((to, from, next) => {
    // 设置页面标题
    const title = to.meta.title ? `${to.meta.title} - 图公主` : '图公主 - 智能相机应用';
    document.title = title;

    // 动态更新meta description
    if (to.meta.description) {
        let metaDesc = document.querySelector('meta[name="description"]');
        if (!metaDesc) {
            metaDesc = document.createElement('meta');
            metaDesc.name = 'description';
            document.head.appendChild(metaDesc);
        }
        metaDesc.content = to.meta.description;
    }

    // 动态更新meta keywords
    if (to.meta.keywords) {
        let metaKeywords = document.querySelector('meta[name="keywords"]');
        if (!metaKeywords) {
            metaKeywords = document.createElement('meta');
            metaKeywords.name = 'keywords';
            document.head.appendChild(metaKeywords);
        }
        metaKeywords.content = to.meta.keywords;
    }

    // 动态更新canonical链接
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
        canonical.href = `https://www.tugongzhu.com${to.path}`;
    }

    // 获取设备类型（考虑用户偏好）
    const deviceType = getDevicePreference();

    // 当前路径是否匹配设备类型
    const isMobilePath = to.path.startsWith('/m');
    const shouldBeMobile = deviceType === 'mobile';

    // 重定向逻辑
    if (shouldBeMobile && !isMobilePath) {
        const mobilePath = `/m${to.path === '/' ? '' : to.path}`;
        return next(mobilePath);
    }

    if (!shouldBeMobile && isMobilePath) {
        const pcPath = to.path.replace('/m', '') || '/';
        return next(pcPath);
    }

    next();
});

function getDevicePreference() {
    // 1. 检查本地存储的用户偏好
    const userPreference = localStorage.getItem('devicePreference');
    if (userPreference) return userPreference;

    // 2. 根据UA检测设备
    const isMobile = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    );

    return isMobile ? 'mobile' : 'pc';
}

export default router;
